import "./ProductTableFooter.css";


const ProductTableFooter = ({ fields, totals }) => {
  return (
    <tfoot>
      <tr>
        <td colSpan={2} className="total-label-cell">Total</td>
        {fields.map((field) => (
          <td key={field.fields + "-footer"} className="total-value-cell">
            {field.fields === "serialNo"
              ? totals[field.fields]
              : field.type === "numberparts"
              ? totals[field.fields] || "0/0"
              : field.type === "number"
              ? (totals[field.fields] || 0).toFixed(2)
              : ""}
          </td>
        ))}
      </tr>
    </tfoot>
  );
};

export default ProductTableFooter;
